import React, { FC } from 'react'

import { ContentfulProcessor, Typography } from '@smarty-nx/ds'

import classes from './FaqBanner.module.scss'

interface FaqBannerProps {
  banner: Queries.GenericBannerFragment
}

const FaqBanner: FC<FaqBannerProps> = ({
  banner: { link, description, image },
}) => (
  <div className={classes.banner}>
    {image && (
      <img
        alt={image.title || ''}
        src={image.url || ''}
        className={classes.image}
        data-testid="simple-banner-image"
        loading="lazy"
        decoding="async"
      />
    )}
    <div className={classes.textContainer}>
      <Typography
        component="h2"
        variant="Kollektif/Large"
        className={classes.title}
        data-testid="simple-banner-title"
      >
        <ContentfulProcessor content={link?.internal.content || ''} />
      </Typography>
      <Typography
        variant="Kollektif/Small"
        className={classes.description}
        data-testid="simple-banner-description"
      >
        <ContentfulProcessor content={description?.internal.content || ''} />
      </Typography>
    </div>
  </div>
)

export default FaqBanner
